module.exports = __webpack_public_path__ + "static/9-adcab2822c82591a066e7e7f5b4de46c.jpg";